import Gallery from '../components/Gallery';
import { BusinessSection, EducationFAQ, EducationFinalCTA, EducationPrice, InstructorSpotlight, LearningSection, Outcomes, Roadmap, StudentCase, WhyTwelveMonths } from '../components/EducationSections';
import { PageHero } from '../components/Primitives';
import { useEducationData } from '../hooks/useEducationData';

export default function EducationPage({ page }) {
  const content = useEducationData();
  const home = content.homeSection;
  const edu = content.educationSection;
  return <>
    <PageHero page={page} eyebrow="BLIV HUNDEFRISØR & SELVSTÆNDIG" />
    <Outcomes section={home('outcomes')} items={content.outcomes} />
    <WhyTwelveMonths section={edu('why')} />
    <LearningSection section={edu('learn')} />
    <BusinessSection section={edu('business') || home('business')} items={content.business} />
    <Roadmap section={home('roadmap')} items={content.roadmap} />
    <StudentCase section={home('case')} story={content.story} />
    <InstructorSpotlight section={home('teacher')} instructor={content.teacher} />
    <Gallery slug={page.gallery_slug} />
    <EducationPrice section={home('training_price')} item={content.coursePrice} />
    <EducationFAQ section={home('faq')} items={content.faq} />
    <EducationFinalCTA section={edu('final') || home('final')} />
  </>;
}
